const Userdata= [

   {
     'id': 1,
     "img":"https://edyoda.s3.amazonaws.com/media/blog-images/learn_machine_learning_courses_online.png",
     "Title":"Introduction To A Machine Learning Online Course",
     "author":"Arman Ahmed",
     "date":21-5-2022,
     "desc":"We have had an insight into Artificial Intelligence. Well, one of its subfields is machine learning and this introduction will help you get a fair idea of what a machine learning online course holds. ..."


   },
   {
    'id':2,
    "img":"https://edyoda.s3.amazonaws.com/media/blog-images/6.png",
    "Title":"Lamp Stack Vs Mean stack: Chossing the...",
    "author":"Edyoda ",
    "date":21-5-2022,
    "desc":"In todays dynamic world, rapid web application development with a smooth user interface that can adapt to specific features is the main business requirement. Many organizations around the  ...",


   },
   {
    'id':3,
    "img":"https://edyoda.s3.amazonaws.com/media/blog-images/4.png",
    "Title":"Impact of Cloud Computing in various industries",
    "author":"shabir",
    "date":21-5-2022,
    "desc":"Cloud computing has been rapidly gaining pace in the world of information technology. It has been observed that over 90% of global enterprises are using cloud . Every industry has its own..."

   },
   {
    'id':4,
    "img":"https://edyoda.s3.amazonaws.com/media/blog-images/3.png",
    "Title":"Challenges of Machine Learning in Big Data Analytics",
    "author":"Edyoda",
    "date":21-5-2022,
    "desc":"Machine Learning is a subset of artificial intelligence which is an important part of computer science. The revolution of Big Data promises to transform the way ..."


   },
   {
    'id':5,
    "img":"https://edyoda.s3.amazonaws.com/media/blog-images/5.png",
    "Title":"Breaking the Myths around Cybersecurity",
    "author":"Ahmed",
    "date":21-5-2022,
    "desc":"As the dependency on online platforms is increasing daily, cybersecurity is becoming an important concern for all companies today. The number of cyberattacks is ever-rising ..."


    },
    {
        'id':6,
        "img":"https://edyoda.s3.amazonaws.com/media/blog-images/7.png",
        "Title":"Importance of Data Backup and Recovery in the IT industry",
        "author":"rajat",
        "date":21-5-2022,
        "desc":"A business must always introspect the areas where they lack in order to bring about a positive change in the work environment. One of the main precautions or..."


  },

  {
        'id':7,
        "img":"https://edyoda.s3.amazonaws.com/media/blog-images/automation-testing-an-overview-2.png",
        "Title":"What is Web Scraping?",
        "author":"manish",
        "date":21-5-2022,
        "desc":"Simply put, web scraping is one of the tools developers use to gather and analyze information from the Internet use to gather and analyze information from the Internet...."

  },

  {
        'id':8,
        "img":"https://edyoda.s3.amazonaws.com/media/blog-images/what_is_isa_blog_1.png",
        "Title":"What is Income Share Agreement?",
        "author":"Edyoda",
        "date":21-5-2022,
        "desc":"The term Income Share Agreement has been around for a long time since 1955 to be precise. Surprised, eh? It was first introduced by Milton Friedman..."
  },

  {
        'id':9,
        "img":"https://edyoda.s3.amazonaws.com/media/blog-images/practical_machine_learning_1.png",
        "Title":"Practical Machine Learning with Python and Keras",
        "author":"Ahmed",
        "date":21-5-2022,
        "desc":"Machine learning is a field of artificial intelligence that uses statistical techniques to give computer systems the ability to “learn” (e.g., progressively improve ..."

  }



]


export default Userdata;